import type { Algorithm } from 'jsonwebtoken';

export const DEFAULT_ALGORITHM: Algorithm = 'HS256';
